import React, { FC, ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { clsx } from 'clsx';
import { useBreakpoints, WebLocation } from '../../customHooks/useBreakpoints';
// components

interface BookingScreensProps {
    children: React.ReactNode;
}

const BookingScreens: FC<BookingScreensProps> = ({ children }): ReactElement => {
    const classes = useStyles();
    const { isMobileSize } = useBreakpoints(WebLocation.FLOW);

    return (
        <div className={clsx(classes.bookingScreensRoot, isMobileSize && classes.bookingScreensRootResponsive)}>
            {children}
        </div>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        bookingScreensRoot: {
            flex: '100%',
            display: 'flex',
            height: '100%',
            width: '100%',
            flexDirection: 'column',
        },
        bookingScreensRootResponsive: {
            height: `calc(100vh)`,
        },
        heightNoMap: {
            height: `calc(100vh - 52px)`,
        },
    }),
);

export default BookingScreens;
